export const resizeDirective = {
  bind(el, binding) {
    if (typeof binding.value !== 'function') {
      console.warn('v-resize should be passed a function as its value');
      return;
    }

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        binding.value(entry);
      }
    });

    observer.observe(el);
    el.__vueResizeObserver__ = observer;
  },
  unbind(el) {
    if (el.__vueResizeObserver__) {
      el.__vueResizeObserver__.unobserve(el);
      el.__vueResizeObserver__.disconnect();
      delete el.__vueResizeObserver__;
    }
  }
};

export default resizeDirective;
